import React from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { PaginationContainer, PaginationButton, PageNumber } from './styles';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    const maxVisible = 3;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, 3, '...', totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage, '...', totalPages);
      }
    }

    return pages;
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  if (totalPages <= 1) return null;

  return (
    <PaginationContainer>
      {/* type="button" em todos: a paginação é renderizada dentro do <form> da
          busca, e um <button> sem type submete o formulário — clicar em uma
          página disparava a busca junto e a navegação não saía do lugar. */}
      <PaginationButton
        type="button"
        onClick={handlePrevious}
        disabled={currentPage === 1}
        aria-label="Página anterior"
      >
        <ArrowLeftOutlined />
      </PaginationButton>

      {getPageNumbers().map((page, index) => {
        if (page === '...') {
          return (
            <PageNumber type="button" disabled key={`ellipsis-${index}`}>
              ...
            </PageNumber>
          );
        }

        return (
          <PageNumber
            type="button"
            key={page}
            isActive={page === currentPage}
            onClick={() => onPageChange(page as number)}
          >
            {page}
          </PageNumber>
        );
      })}

      <PaginationButton
        type="button"
        onClick={handleNext}
        disabled={currentPage === totalPages}
        aria-label="Próxima página"
      >
        <ArrowRightOutlined />
      </PaginationButton>
    </PaginationContainer>
  );
};
